var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79998 5.20029C8.89998 5.50029 9.19998 5.60029 9.49998 5.60029L12.7 4.50029C12.9 4.40029 13.1 4.20029 13.1 4.00029V0.800293C13.1 0.500293 12.9 0.300293 12.5 0.300293C12.2 0.300293 12 0.500293 12 0.800293V2.80029C9.29998 0.200293 4.89998 0.300293 2.29998 3.00029C-0.300018 5.70029 -0.200021 10.1003 2.49998 12.7003C5.19998 15.3003 9.59998 15.2003 12.2 12.5003C13.7 10.9003 14.4 8.70029 14 6.60029C14 6.30029 13.7 6.10029 13.4 6.20029C13.1 6.20029 12.9 6.50029 13 6.80029C13.5 10.0003 11.3 13.0003 8.19998 13.6003C4.99998 14.1003 1.99998 12.0003 1.49998 8.80029C0.899979 5.60029 3.09998 2.60029 6.29998 2.10029C8.29998 1.70029 10.3 2.50029 11.7 3.90029L9.29998 4.70029C8.89998 4.70029 8.69998 5.00029 8.79998 5.20029Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5748c1cb6fc1a86a5c93e52311290e3b.svg";
export { ForwardRef as ReactComponent };